import * as yup from "yup";

export const socialMediaPlanSchema = yup.object().shape({
  pageName: yup.string().required("Page Name is required"),

  format: yup.string().required("Format is required"),

  startDate: yup.string().required("Start Date is required"),

  endDate: yup.string(),

  days: yup.array().when("endDate", {
    is: (endDate) => !!endDate,
    then: (schema) => schema.min(1, "Please select at least one day"),
    otherwise: (schema) => schema.notRequired(),
  }),

  time: yup.string(),
  platforms: yup.array(),
  scheduleName: yup.string(),
  contentType: yup.string(),

  // fileFormat: yup.string(),

  // filepath: yup.mixed().when("fileFormat", {
  //   is: (fileFormat) => !!fileFormat,
  //   then: (schema) => schema.required("Please upload a file"),
  //   otherwise: (schema) => schema.notRequired(),
  // }),

  // topic: yup.string(),

  // description: yup.string(),
  // uploadThumbnail: yup.string(),
});
